import Step from './step';
import $    from 'jquery';

/**
 * FormStep class
 */

export default class FormStep extends Step {

  /**
   * FormStep constructor
   *
   * Must be initialized with:
   *
   * $el – a root jQuery object containing an HTMLFormElement
   *
   * @param  {Object} config – configuration data
   * @return {Step}
   */

  constructor( config ) {
    super( config );

    if ( !( this.$el[ 0 ] instanceof HTMLFormElement ) ) {
      const msg = `this.$el must be a jQuery object containing a form, ` +
                  `got ${ this.el }`;
      throw new TypeError( msg );
    }

    this.bindEvents();
  }

  /**
   * Bind form event handlers
   *
   * @return {FormStep}
   */

  bindEvents() {
    this.$el.on( 'submit', this.onSubmit.bind( this ) );
    this.$el.on( 'change input', this.onChange.bind( this ) );
    this.$el.on( 'focusout', this.onBlur.bind( this ) );

    return this;
  }

  /**
   * Handle form submissions
   *
   * @param  {Event} e – form submission event
   * @return {Undefined}
   */

  onSubmit( e ) {
    e.preventDefault();
    this.$el.find(':focus').blur();
    this.emit('submit');
  }

  /**
   * Handle form changes
   *
   * Dispatches a `change` event with the serialized form data
   *
   * @param  {Event} e – input/change event
   * @return {Undefined}
   */

  onChange( e ) {
    const $input = $( e.target );
    const name   = $input.attr('name');

    let value = $input.attr('type') === 'checkbox'
      ? $input.prop('checked')
      : $input.val();

    // apply transformation
    if ( this.transforms && this.transforms[ name ] ) {
      value = this.transforms[ name ]( value );
    }

    const valid = this.validateProp( name, value );

    if ( valid ) {
      $input.removeClass('error');
      this.$el.find( `.error-message--${ name }` ).remove();
    }

    this.dispatch({ type: 'change', data: { [ name ]: value } });
  }

  /**
   * Handle blur events
   *
   * Adds error classes if the input is invalid
   *
   * @param  {Event} e – DOM event
   * @return {Undefined}
   */

  onBlur( e ) {
    const $input = $( e.target );
    const name   = $input.attr('name');

    let value = $input.val();

    // apply transformation
    if ( this.transforms && this.transforms[ name ] ) {
      value = this.transforms[ name ]( value );
    }

    const valid  = this.validateProp( name, value );

    if ( !valid ) {
      $input.addClass('error');
    }
  }

  /**
   * Serialize the root form
   * @return {Object}
   */

  serialize() {
    const props = this.$el.serializeArray();
    const data  = {};

    props.forEach( prop => data[ prop.name ] = prop.value );

    return data;
  }

}
